import { useEffect } from "react";
import { registerTourValidator } from "./tourValidation";

/** Register a field validator while a manual tour substep is active. */
export function useTourFieldValidator(stepId, subId, active, validate) {
  useEffect(() => {
    if (!active || !stepId || !subId || typeof validate !== "function") {
      return undefined;
    }
    return registerTourValidator(stepId, subId, validate);
  }, [stepId, subId, active, validate]);
}
